import React, { forwardRef } from 'react';
import { Button as ButtonUDL } from './component';
import { Button as ButtonLegacy } from './component.legacy';
import { Props } from './types';

export type { Props as ButtonProps, ButtonStyle } from './types';

export const Button = forwardRef<HTMLButtonElement, Props>(({ renderAsLegacy, ...props }, ref) => {
  if (renderAsLegacy || props.branded || (props.chakra && props.chakra === 'off')) {
    return <ButtonLegacy {...props} ref={ref} />;
  }
  return <ButtonUDL {...props} ref={ref} />;
});

Button.displayName = 'Button';
